/* eslint-disable no-useless-constructor */
import { Controller, Menu } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { MenuKey } from '../../schema/menu-schema/common';
import { MENU_CONFIGS } from './config';
import LocalFileFolderFeature from './file-folder-feature';

@Controller({ menuItems: MENU_CONFIGS })
export class LocalFileFolderController {
    constructor(private readonly feature: LocalFileFolderFeature) {
    }

    @Menu(MenuKey.LOCAL_FILE_FOLDER, 'onClick')
    public openLocalFileFolder(): void {
        this.feature.openLocalFileFolder();
    }

    @Menu(MenuKey.LOCAL_FILE_FOLDER, 'shouldHide')
    public hideLocalFileFolder(): boolean {
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.localFileFolder);
    }

    @Menu(MenuKey.LOCAL_FILE_FOLDER, 'shouldDisabled')
    public disableLocalFileFolder(): boolean {
        return this.feature.shouldDisabled(MenuKey.LOCAL_FILE_FOLDER);
    }
}
